export default __webpack_public_path__ + "static/media/04_east_flower_b2.8307c8c1.mp4";